module.exports = __webpack_public_path__ + "img/works_rakuten_gora_3.6e98d6b7.png";